// ABOUTME: The /application-status/:applicationRefId route: the landing the status emails from pro-core link to,
// ABOUTME: which hands the talent on to the screen their arm of the experiment gives them.
import { Navigate, useParams } from 'react-router-dom';
import { PATHS } from 'config/paths';
import { StatusEmailLink } from 'modules/applications';

/**
 * Behind the auth guard, because the arm is per talent and the destination is their own: a talent arriving from the
 * mail signs in first and comes back here. A link without an application to name is nothing but a way into the app,
 * so it opens the home screen.
 */
export const ApplicationStatusLinkPage = () => {
  const { applicationRefId } = useParams();

  if (!applicationRefId) {
    return <Navigate to={PATHS.root} replace />;
  }

  return <StatusEmailLink refId={applicationRefId} />;
};
